﻿import * as React from "react";
import { IBaseSectionProps } from "./IBaseSectionProps";

export const LogoutSection: React.FunctionComponent<IBaseSectionProps> = (
    props,
): React.ReactElement => (
    <div className={`tab-section`}>
        <a href={`/Account/Logout`} target={`_self`}>
            <img alt={props.name} src={`/Images/LogoutSectionIcon.svg`} />
        </a>
    </div>
);
